module.exports = __webpack_public_path__ + "img/h2.22170722.png";